// ============================================================
// ANSICHTSSACHE-AGENT – Tooltip Component
// ============================================================

"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  side?: "top" | "bottom";
  className?: string;
}

function Tooltip({ content, children, side = "top", className }: TooltipProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          className={cn(
            "text-caption text-text-inverse bg-bg-inverse shadow-dropdown animate-fade-in absolute z-50 rounded px-2 py-1 whitespace-nowrap",
            side === "top"
              ? "bottom-full left-1/2 mb-1.5 -translate-x-1/2"
              : "top-full left-1/2 mt-1.5 -translate-x-1/2",
            className,
          )}
        >
          {content}
        </div>
      )}
    </div>
  );
}

export { Tooltip };
